import { render, staticRenderFns } from "./AccountDeletion.vue?vue&type=template&id=f5cd5e1a&scoped=true"
import script from "./AccountDeletion.vue?vue&type=script&lang=js"
export * from "./AccountDeletion.vue?vue&type=script&lang=js"
import style0 from "./AccountDeletion.vue?vue&type=style&index=0&id=f5cd5e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cd5e1a",
  null
  
)

export default component.exports